module.exports = __webpack_public_path__ + "img/tri-logo-small.134d8dd0.png";